import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { i18n } from '@/locales';
import InputRow from '@/components/Form/InputRow.vue';
import { getGlobalStore } from '@/lib/global-store';
const lc = 'views.store_delivery_possible_area.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LeftContentController',
    setup(__props) {
        const locale = {
            siDo: i18n.t(`${lc}si_do`),
            siGunGu: i18n.t(`${lc}si_gun_gu`),
        };
        const placeholderLocale = {
            siDo: i18n.t('common.select_field_placeholder', {
                field: locale.siDo,
            }),
            siGunGu: i18n.t('common.select_field_placeholder', {
                field: locale.siGunGu,
            }),
        };
        const vuexStore = getGlobalStore();
        const siDoList = computed(() => vuexStore.state.storeDeliveryPossibleArea.siDoList.constantGroups);
        const selectedSiDo = computed({
            get() {
                return vuexStore.state.storeDeliveryPossibleArea.selectedSiDo?.constantGroupId || null;
            },
            set(value) {
                const selected = siDoList.value.find((item) => item.constantGroupId === value);
                vuexStore.dispatch('storeDeliveryPossibleArea/setSiDo', selected);
            },
        });
        const isSiDoSelected = computed(() => !selectedSiDo.value);
        const siGunGuList = computed(() => vuexStore.state.storeDeliveryPossibleArea.siGunGuList.constantGroups);
        const selectedSiGunGu = computed({
            get() {
                return vuexStore.state.storeDeliveryPossibleArea.selectedSiGunGu?.constantGroupId || null;
            },
            set(value) {
                const selected = siGunGuList.value.find((item) => item.constantGroupId === value);
                vuexStore.dispatch('storeDeliveryPossibleArea/setSiGunGu', selected);
            },
        });
        return (_ctx, _cache) => {
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                        cols: "6",
                        class: "pt-0 pr-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(InputRow, {
                                label: locale.siDo,
                                "is-vertical-label": "",
                                "is-required": ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                        modelValue: selectedSiDo.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSiDo).value = $event)),
                                        "item-title": "name",
                                        "item-value": "constantGroupId",
                                        items: siDoList.value,
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        placeholder: placeholderLocale.siDo
                                    }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { class: "pt-0 pl-2" }, {
                        default: _withCtx(() => [
                            _createVNode(InputRow, {
                                label: locale.siGunGu,
                                "is-vertical-label": "",
                                "is-required": ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                        modelValue: selectedSiGunGu.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedSiGunGu).value = $event)),
                                        "item-title": "name",
                                        "item-value": "constantGroupId",
                                        items: siGunGuList.value,
                                        disabled: isSiDoSelected.value,
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        placeholder: placeholderLocale.siGunGu
                                    }, null, 8 /* PROPS */, ["modelValue", "items", "disabled", "placeholder"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
